import { ChallengeSession } from 'reducers/programs/types';
import colors from 'constants/colors';

export const SESSION_TYPES = {
  challenge: { label: 'Challenge', color: colors.main.ruby },
  lowIntensity: { label: 'Low intensity', color: colors.main.blue },
} as const;

export type SessionType = keyof typeof SESSION_TYPES;

type SessionFlags = { isBasic?: boolean; challengeOrder?: number | null };

export function getSessionType(session: SessionFlags | null | undefined): SessionType | null {
  if (session?.challengeOrder != null) return 'challenge';
  if (session?.isBasic) return 'lowIntensity';
  return null;
}

/**
 * A challenge is only offered when it can fill the duration the user already
 * committed to; the exercise swap filters by that length and an unsupported
 * one would leave the workout empty after the prep phase.
 */
export function getOfferableChallengeSession(
  challengeSession: ChallengeSession | null | undefined,
  timeLength: number | string | null | undefined,
): ChallengeSession | null {
  if (!challengeSession || timeLength == null) return null;
  return challengeSession.durationOptions?.[String(timeLength)] ? challengeSession : null;
}
